import Card from './Card.vue'

export default Card
